/** Impayés : échéance dépassée, reste TTC. */
import { useFormatters } from "../../formats/useFormatters";
import { ListPager, usePagedRows } from "../../components/ListPager";
import { SortTh, sortRows, useTableSort } from "../../components/tableSort";
import "../clients/tables.css";
import type { ReportUnpaid } from "./types";

type UnpaidTableProps = {
  rows: ReportUnpaid[];
  onOpenInvoice?: (id: number) => void;
  onOpenClient?: (clientId: number) => void;
};

export function UnpaidTable({ rows, onOpenInvoice, onOpenClient }: UnpaidTableProps) {
  const { money, day } = useFormatters();
  const sort = useTableSort<"number" | "client" | "due" | "late" | "rest">();
  const shown = sort.key
    ? sortRows(rows, sort.dir, sort.key === "due" ? "date" : sort.key === "late" || sort.key === "rest" ? "num" : "text", (r) => {
        if (sort.key === "number") return r.number || "";
        if (sort.key === "client") return r.client_name || "";
        if (sort.key === "due") return r.due_date || "";
        if (sort.key === "late") return r.days_late;
        return r.remaining_cents;
      })
    : rows;
  const paged = usePagedRows(shown);
  if (rows.length === 0) {
    return <p className="fx-clients-empty">Aucune facture en retard.</p>;
  }
  return (
    <div className="fx-clients-wrap">
      <table className="fx-clients-table">
        <thead>
          <tr>
            <SortTh label="N°" active={sort.key === "number"} dir={sort.dir} onSort={() => sort.onSort("number", "text")} />
            <SortTh label="Client" active={sort.key === "client"} dir={sort.dir} onSort={() => sort.onSort("client", "text")} />
            <SortTh label="Échéance" active={sort.key === "due"} dir={sort.dir} onSort={() => sort.onSort("due", "date")} />
            <SortTh className="is-num" label="Retard" active={sort.key === "late"} dir={sort.dir} onSort={() => sort.onSort("late", "num")} />
            <SortTh className="is-num" label="Reste TTC" active={sort.key === "rest"} dir={sort.dir} onSort={() => sort.onSort("rest", "num")} />
          </tr>
        </thead>
        <tbody>
          {paged.slice.map((r) => (
            <tr key={r.id}>
              <td>
                {onOpenInvoice ? (
                  <button type="button" className="fx-clients-table__link" onClick={() => onOpenInvoice(r.id)}>
                    {r.number || "—"}
                  </button>
                ) : (
                  r.number || "—"
                )}
              </td>
              <td>
                {onOpenClient && r.client_id ? (
                  <button type="button" className="fx-clients-table__link" onClick={() => onOpenClient(r.client_id)}>
                    {r.client_name || "—"}
                  </button>
                ) : (
                  r.client_name || "—"
                )}
              </td>
              <td>{day(r.due_date)}</td>
              <td className="is-num is-due">{r.days_late} j</td>
              <td className="is-num is-due">{money(r.remaining_cents)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <ListPager page={paged.page} pages={paged.pages} total={paged.total} from={paged.from} to={paged.to} setPage={paged.setPage} />
    </div>
  );
}
